import { fade } from "@remotion/transitions/fade";
import { none } from "@remotion/transitions/none";
import { slide, SlideDirection } from "@remotion/transitions/slide";

import { SceneTransitionDto } from "@repo/api/overlays";
import { easeInCubic, easeInOutCubic, easeOutCubic, linear } from "./easing.ts";

export function getTransitionPresentation(
  transition: SceneTransitionDto,
  sceneType: "startScene" | "endScene",
) {
  if (["FADE_IN", "FADE_OUT"].includes(transition.kind)) {
    return fade();
  }

  if (transition.kind === "STACKED") {
    // The exiting start scene would otherwise render below the main scene.
    return sceneType === "startScene"
      ? none({ exitStyle: { zIndex: 1 } })
      : none();
  }

  if (["SLIDE_IN", "SLIDE_OUT"].includes(transition.kind)) {
    return slide({
      direction: parseRemotionDirection(transition.direction),
    });
  }

  throw new Error(`Unknown transition kind: ${transition.kind}`);
}

function parseRemotionDirection(direction: SceneTransitionDto["direction"]) {
  const directions: Record<SceneTransitionDto["direction"], SlideDirection> = {
    FROM_LEFT: "from-left",
    FROM_RIGHT: "from-right",
    FROM_TOP: "from-top",
    FROM_BOTTOM: "from-bottom",
  };

  return directions[direction];
}

export function getTransitionEasing(transition: SceneTransitionDto) {
  const easings: Record<SceneTransitionDto["easing"], (t: number) => number> = {
    LINEAR: linear,
    EASE_IN: easeInCubic,
    EASE_OUT: easeOutCubic,
    EASE_IN_OUT: easeInOutCubic,
  };

  return easings[transition.easing];
}
